import { render, staticRenderFns } from "./XyLabel.vue?vue&type=template&id=15c4eb74&scoped=true&"
import script from "./XyLabel.vue?vue&type=script&lang=js&"
export * from "./XyLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c4eb74",
  null
  
)

export default component.exports